import { useSearchParams } from 'react-router-dom';

/**
 * Keeps a single list filter in the URL query string so it survives browser
 * back/forward navigation and page reloads (same approach as `useSearch`).
 *
 * @param {string} key   query string key (e.g. "countryId")
 * @returns {[string, function]} current value ('' when absent) and a setter;
 *   setting an empty value removes the key from the URL.
 */
function useUrlParam(key) {
  const [searchParams, setSearchParams] = useSearchParams();
  const value = searchParams.get(key) || '';

  const setValue = (nextValue) => {
    const nextParams = Object.fromEntries(searchParams);
    const normalized = nextValue === undefined || nextValue === null ? '' : `${nextValue}`;
    if (normalized.length > 0) {
      nextParams[key] = normalized;
    } else {
      delete nextParams[key];
    }
    setSearchParams(nextParams);
  };

  return [value, setValue];
}

export default useUrlParam;
